import { getGuestRating } from '@apps/main/new-desktop/modules/customersRating';
import type { LatLongPoint } from '@apps/main/new-desktop/modules/newMaps';

import type {
  DestinationStaticInfo,
  ContentApiImage,
  IngredientId,
  OverviewDestinationStaticInfo,
} from '@libs/trip-planner-interfaces';

import type { HotelMapCardData, HighlightedHotel } from '../../models';

export function getHotelMapCardData(
  hotelMapCard: HighlightedHotel | undefined,
  getStaticInfo: (
    hotelCode: string,
    ingredientId: IngredientId
  ) => DestinationStaticInfo | OverviewDestinationStaticInfo | undefined,
  getImage: (
    image: ContentApiImage,
    hotelCode?: string,
    width?: number,
    height?: number
  ) => string
): HotelMapCardData | undefined {
  if (!hotelMapCard) {
    return;
  }

  const { ingredientId, hotelCode } = hotelMapCard;
  const staticInfo = getStaticInfo(hotelCode, ingredientId);

  if (!staticInfo || !staticInfo.images || !staticInfo.images[0]) {
    return;
  }

  const guestRating = getGuestRating(staticInfo.guestRatings);

  return {
    ingredientId: ingredientId,
    ingredientIndex: hotelMapCard.ingredientIndex,
    hotelCode: hotelCode,
    hotelName: staticInfo.name,
    starsRating: staticInfo.semboSunRating,
    imageUrls: staticInfo.images.map((image) => getImage(image)),
    accommodationType: staticInfo.typeOfHotel,
    guestRating,
  };
}

export function getHighlightedHotel(
  hotelCode: string | undefined,
  ingredientId: IngredientId | undefined,
  ingredientIndex: number,
  position: LatLongPoint | undefined
): HighlightedHotel | undefined {
  if (hotelCode && ingredientId) {
    return {
      hotelCode,
      ingredientId,
      ingredientIndex,
      showHotelMapCard: false,
      position,
    };
  } else {
    return undefined;
  }
}
